import isPlainObject from 'lodash/isPlainObject';
import isArray from 'lodash/isArray';
import { getClient } from './client';

export function promote(keyToPromote) {
  return (obj) => {
    const promoteDeep = promote(keyToPromote);
    if (isArray(obj)) {
      return obj.map((x) => promoteDeep(x));
    }

    const keys = Object.keys(obj);
    return keys.reduce((acc, key) => {
      const val = obj[key];
      if (isPlainObject(val)) {
        if (val[keyToPromote]) {
          return {
            ...acc,
            [key]: promoteDeep(val[keyToPromote]),
          };
        }
        return {
          ...acc,
          [key]: promoteDeep(val),
        };
      }
      if (isArray(val)) {
        return {
          ...acc,
          [key]: val.map((x) => promoteDeep(x)),
        };
      }

      return acc;
    }, obj);
  };
}

const removeENLocalization = promote('en-US');

/**
 * @memberof module:contentful
 * @param {string} environmentName The name of the contentful environment. Valid
 * options are `preview` or `production`. NOTE: This is a contentful environment
 * not a normal updater environment.
 * @param {Array} entryIds Which entrys to save
 * @returns {Promise} space A promise that's resolved with an object containing all of the space data that's
 * been requested or an empty object if no data is found.
 *
 * @description Syncs the requested entries from the requested environment
 */
export function sync(environmentName, entryIds) {
  const client = getClient(environmentName);
  if (!client) {
    // eslint-disable-next-line no-console
    console.error('Failed to create a client for ', environmentName);
  }

  return client
    .sync({ initial: true, resolveLinks: true })
    .then((r) => {
      // eslint-disable-next-line @typescript-eslint/no-shadow
      const state = r.entries.reduce((state, entry) => {
        if (entryIds.includes(entry.sys.id)) {
          return {
            ...state,
            [entry.sys.id]: entry,
          };
        }

        return state;
      }, {});
      return removeENLocalization(state);
    })
    .catch((e) => {
      // eslint-disable-next-line no-console
      console.error(e);
      return {};
    });
}
